import { useMemo } from 'react';
import { useSubscriptionAccess } from './useSubscriptionAccess';

export type AccessType = 'subscription' | 'credits' | 'free_access' | 'none' | 'error';

export const useReadOnlyMode = () => {
  const { hasAccess, loading, accessType } = useSubscriptionAccess();

  const isReadOnly = useMemo(() => {
    if (loading) return false;
    return !hasAccess;
  }, [loading, hasAccess]);

  return { isReadOnly, loading, accessType: (accessType as AccessType) };
};


